import { motion } from "framer-motion";

const Bar = ({ label, value, goal, color, testid }) => (
  <div>
    <div className="mb-1.5 flex justify-between font-mono text-xs">
      <span className="uppercase tracking-widest text-[#a3b1aa]">{label}</span>
      <span data-testid={testid}>{Math.round(value)} / {goal} g</span>
    </div>
    <div className="h-2 bg-white/10">
      <motion.div className="h-full" style={{ background: color }} initial={false}
        animate={{ width: `${Math.min(100, goal ? (value / goal) * 100 : 0)}%` }} transition={{ duration: 0.8 }} />
    </div>
  </div>
);

export const DaySummary = ({ totals, goals }) => {
  const kcal = totals?.kcal ?? 0;
  const goal = goals?.kcal ?? 2000;
  const pct = Math.min(1, goal ? kcal / goal : 0);
  const r = 70;
  const c = 2 * Math.PI * r;
  const left = Math.round(goal - kcal);

  return (
    <section data-testid="day-summary" className="grid items-center gap-8 border border-[rgba(152,191,162,0.15)] bg-[#0b120e] p-6 sm:grid-cols-[auto_1fr] md:p-8">
      <div className="relative mx-auto h-44 w-44">
        <svg viewBox="0 0 160 160" className="h-full w-full -rotate-90">
          <circle cx="80" cy="80" r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="12" />
          <motion.circle cx="80" cy="80" r={r} fill="none" stroke={kcal > goal ? "#f0a78f" : "#98bfa2"} strokeWidth="12" strokeLinecap="round"
            strokeDasharray={c} initial={false} animate={{ strokeDashoffset: c * (1 - pct) }} transition={{ duration: 1 }} />
        </svg>
        <div className="absolute inset-0 grid place-items-center text-center">
          <div>
            <p data-testid="kcal-consumed" className="font-display text-5xl font-900 leading-none">{Math.round(kcal)}</p>
            <p className="font-mono text-[11px] uppercase tracking-widest text-[#a3b1aa]">di {goal} kcal</p>
          </div>
        </div>
      </div>
      <div className="space-y-4">
        <p data-testid="kcal-remaining" className="font-display text-2xl font-800 uppercase">
          {left >= 0 ? <>Restano <span className="text-[#c4dcca]">{left}</span> kcal</> : <>Superato di <span className="text-[#f0a78f]">{-left}</span> kcal</>}
        </p>
        <Bar label="Proteine" value={totals?.protein ?? 0} goal={goals?.protein ?? 0} color="#c4dcca" testid="protein-progress" />
        <Bar label="Carboidrati" value={totals?.carbs ?? 0} goal={goals?.carbs ?? 0} color="#98bfa2" testid="carbs-progress" />
        <Bar label="Grassi" value={totals?.fat ?? 0} goal={goals?.fat ?? 0} color="#6f9a7c" testid="fat-progress" />
      </div>
    </section>
  );
};
